import { OnInit, EventEmitter } from '@angular/core';
import { ReviewSummary } from '../models/review-summary.model';
import { FormControl } from '@angular/forms';
var ReviewOverviewComponent = /** @class */ (function () {
    function ReviewOverviewComponent() {
        this.sizeModifier = '';
        this.noReviewsText = 'No reviews';
        this.isHeader = true;
        this.sortReviewsBy = new EventEmitter();
        this.sortBy = new FormControl();
    }
    ReviewOverviewComponent.prototype.ngOnInit = function () {
        this.sortBy.setValue('likes');
    };
    Object.defineProperty(ReviewOverviewComponent.prototype, "ratingLabel", {
        get: function () {
            var count = this.reviewSummary.countRatings;
            var suffix = (count === 1) ? '' : 's';
            return count + " rating" + suffix;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReviewOverviewComponent.prototype, "reviewLabel", {
        get: function () {
            var count = this.reviewSummary.countReviews;
            var suffix = (count === 1) ? '' : 's';
            return count + " review" + suffix;
        },
        enumerable: true,
        configurable: true
    });
    ReviewOverviewComponent.prototype.reSort = function (sortBy) {
        this.sortReviewsBy.emit(sortBy);
    };
    return ReviewOverviewComponent;
}());
export { ReviewOverviewComponent };
